<template>
  <div class="mb-8">
    {{ $t("firstPasswordRegistration.rules.description") }}

    <div v-for="(rule, key) in rules" :key="key" class="d-flex align-center">
      <v-icon :color="rule.error ? 'red lighten-1' : 'green'" class="pr-1">
        {{ rule.error ? "mdi-close" : "mdi-check" }}
      </v-icon>
      <span :class="rule.error ? 'red--text text--lighten-1' : 'green--text'">
        {{ rule.message }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: Object,
    },
  },
};
</script>
